import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { AUTHOR } from "@/constants/testIds";
import RevealLines from "@/components/site/RevealLines";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.19, 1, 0.22, 1] },
  },
};

export default function Authors() {
  const [authors, setAuthors] = useState([]);
  useEffect(() => {
    api.get("/authors").then((r) => setAuthors(r.data));
  }, []);

  return (
    <main className="pt-32 md:pt-40 pb-32 px-6 md:px-10">
      <div className="max-w-[1600px] mx-auto">
        <div className="text-[10px] tracking-[0.35em] uppercase text-[color:var(--vv-bone-dim)] mb-6">
          — The Roster
        </div>
        <h1 className="font-serif-vv text-6xl md:text-[10vw] leading-[0.9] tracking-tighter">
          <RevealLines lines={["Authors."]} />
        </h1>

        <div className="mt-20 space-y-24">
          {authors.map((a, i) => (
            <motion.div
              key={a.id}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: (i % 3) * 0.08 }}
              data-testid={AUTHOR.card(a.slug)}
              className="grid grid-cols-12 gap-6 md:gap-12 border-t vv-line pt-12 group"
            >
              <div className="col-span-12 md:col-span-2 text-[10px] tracking-[0.3em] uppercase text-[color:var(--vv-bone-dim)]">
                N° {String(i + 1).padStart(2, "0")}
              </div>
              <div className="col-span-12 md:col-span-3">
                <div className="book-frame relative aspect-[4/5] border vv-line p-4 bg-[color:var(--vv-surface)] overflow-hidden">
                  {a.portrait_url && (
                    <motion.img
                      src={a.portrait_url}
                      alt={a.name}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000"
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
                    />
                  )}
                </div>
              </div>
              <div className="col-span-12 md:col-span-7">
                <h2 className="font-serif-vv text-5xl md:text-7xl leading-none tracking-tight group-hover:italic transition-all duration-500">
                  {a.name}
                </h2>
                {a.origin && (
                  <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-[color:var(--vv-bone-dim)]">
                    {a.origin}
                  </div>
                )}
                <p className="mt-6 text-lg leading-relaxed text-[color:var(--vv-bone)]/85 max-w-2xl">
                  {a.bio}
                </p>
                <Link
                  to="/catalog"
                  className="mt-8 inline-block text-xs uppercase tracking-[0.3em] vv-link text-[color:var(--vv-ember)]"
                >
                  See their titles →
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </main>
  );
}
